import type { TileState } from "./types";

const EXTENSION_BY_MIME_TYPE: Record<string, string> = { "image/png": "png", "image/jpeg": "jpg", "image/webp": "webp" };

function toFile(blob: Blob, name: string, mimeType: string): File {
  const extension = EXTENSION_BY_MIME_TYPE[mimeType] ?? "png";
  return new File([blob], `${name}.${extension}`, { type: mimeType });
}

export async function fileFromTile(tile: TileState): Promise<File> {
  const name = tile.stylePresetLabel;
  if (tile.pendingBase64 && tile.pendingMimeType) {
    const bytes = Uint8Array.from(atob(tile.pendingBase64), (char) => char.charCodeAt(0));
    return toFile(new Blob([bytes], { type: tile.pendingMimeType }), name, tile.pendingMimeType);
  }
  if (!tile.imageUrl) throw new Error("Tile has no image");
  // cache: "reload" avoids a cached copy that the <img> loaded without CORS headers.
  const response = await fetch(tile.imageUrl, { cache: "reload" });
  if (!response.ok) throw new Error(`Failed to fetch image (${response.status})`);
  const blob = await response.blob();
  return toFile(blob, name, blob.type || "image/png");
}
